'use strict';

angular.module('cimerFrontEndApp').directive('project', ['$http', 'ApiUrl',
function ($http, ApiUrl) {
    return {
        restrict: 'E',
        templateUrl: '/Content/Templates/projectTemplate.html',
        scope: {
            projectID: '=ngModel',
            classes: '@classes',
            isRequired: '=?isRequired'
        },
        require: ['^form', 'ngModel'],
        link: function (scope, elements, attrs, ctrls) {
            var ngModel = ctrls[1];
            var _apiUrl = ApiUrl.url('/Project/');

            $http.get(_apiUrl + 'AllProjects').then(function (response) {
                scope.projects = response.data;
            }, function (err) {
                //TODO: error
            });

        }
    };
}]);
